import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRight from '@material-ui/icons/ArrowRightAlt'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useNavigate } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import $ from "jquery";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {

        marginLeft: 240,
    },
    drawer: {
        width: '100%',
        flexShrink: 0,
    },
    drawerPaper: {
        width: 100,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: "none !important",
        border: "1px solid #F1F1F1",

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
}));

const SidebarUser = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [isMobile, setisMobile] = React.useState();
    const [value, setValue] = React.useState(0);
    const [more, setMore] = React.useState(true);
    const [less, setLess] = React.useState(true);
    const [plan, setPlan] = React.useState(true);
    const [add, setAdd] = React.useState(true);
    const navigate = useNavigate();

    const UserMgntNavigation = (e) => {
        $("#closemodal").trigger("click")
        $("#closemodal1").trigger("click")
        e === 1 ? navigate("/usermanagement/admin") :
            e === 2 ? navigate("/usermanagement/shipowner") :
                e === 3 ? navigate("/usermanagement/yardowner") :
                    e === 4 ? navigate("/usermanagement/supervisior") : navigate("")
    }

    useEffect(() => {
        window.addEventListener('resize', resize);
        const interval = setInterval(() => {
            resize()
        }, 100);
        return () => clearInterval(interval);
    }, []);

    const resize = () => {
        if (window.innerWidth < 850) { setisMobile(true) }
        else { setisMobile(false) }
        $("#Settings1 .MuiListItemText-primary").addClass("spanTopBar");
    };

    return (
        <>
            {isMobile ?
                <div className={classes.root}>
                    <CssBaseline />
                    <List className="pt-4 mt-5 w-100 " style={{ backgroundColor: "#F6F6F6", height: "calc(100vh)", width: 240, bottom: 0 }} >
                        <ListItem className='border-bottom' >
                            <ListItemText id={"Settings" + "1"} className='pl-3 textNaviIcon' primary="Users" />
                            <NavigateBeforeIcon id="Settings" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        {[{ 'id': 'UserMngt0', 'text': 'Admin' }, { 'id': 'UserMngt1', 'text': 'Ship Owner' }, { 'id': 'UserMngt2', 'text': 'Yard In Charge' }, { 'id': 'UserMngt3', 'text': 'Supervisior' }].map((text, index) => (
                            <ListItem className="" button key={text.text} onClick={() => { UserMgntNavigation(index + 1) }}>
                                <ListItemText className="px-3 ml-3 textNaviIcon" id={text.id} primary={text.text} />
                                <NavigateNextIcon className="naviIcon d-none" id={text.id + index} style={{ width: 23, height: 23 }} />
                            </ListItem>
                        ))}
                    </List>
                </div>
                : navigate('/usermanagement/admin')
            }
        </>
    )
}
export default SidebarUser;